import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LayoutDashboard, Settings, LogOut, ShieldCheck, ListChecks, CalendarClock, Megaphone } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { useBrand } from "../../context/BrandContext";

export function AdminShell({ children, title, actions }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, user } = useAuth();
  const s = useBrand();

  const nav = [
    { to: "/admin", label: "Dashboard", icon: LayoutDashboard },
    { to: "/admin/questions", label: "Questions", icon: ListChecks },
    { to: "/admin/meetings", label: "Meetings", icon: CalendarClock },
    { to: "/admin/campaigns", label: "Campaigns", icon: Megaphone },
    { to: "/admin/settings", label: "Settings", icon: Settings },
  ];

  return (
    <div className="min-h-screen flex bg-slate-50">
      {/* sidebar */}
      <aside className="hidden md:flex w-64 flex-col bg-navy text-white">
        <div className="h-16 flex items-center gap-2.5 px-5 border-b border-white/10">
          <div className="grid place-items-center h-9 w-9 rounded-xl bg-white/10"><ShieldCheck className="text-gold" size={18} /></div>
          <div className="leading-tight">
            <div className="font-heading font-extrabold text-sm">{s.business_name}</div>
            <div className="text-[10px] tracking-[0.16em] uppercase text-white/50">Admin</div>
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {nav.map((n) => {
            const active = location.pathname === n.to;
            return (
              <button key={n.to} data-testid={`nav-${n.label.toLowerCase()}`} onClick={() => navigate(n.to)}
                className={`w-full flex items-center gap-3 rounded-xl px-4 py-2.5 text-sm font-semibold transition-colors duration-200 ${active ? "bg-white/10 text-gold" : "text-white/70 hover:bg-white/5"}`}>
                <n.icon size={18} /> {n.label}
              </button>
            );
          })}
        </nav>
        <div className="p-3 border-t border-white/10">
          <div className="px-4 py-2 text-xs text-white/50 truncate">{user?.email}</div>
          <button data-testid="logout-btn" onClick={() => { logout(); navigate("/admin/login"); }}
            className="w-full flex items-center gap-3 rounded-xl px-4 py-2.5 text-sm font-semibold text-white/70 hover:bg-white/5 transition-colors duration-200">
            <LogOut size={18} /> Logout
          </button>
        </div>
      </aside>

      {/* main */}
      <div className="flex-1 min-w-0">
        <header className="sticky top-0 z-20 h-16 bg-white border-b border-slate-200 flex items-center justify-between px-5 md:px-8">
          <h1 className="font-heading font-extrabold text-navy text-lg tracking-tight">{title}</h1>
          <div className="flex items-center gap-3">{actions}</div>
        </header>
        <main className="p-5 md:p-8">{children}</main>
      </div>
    </div>
  );
}
